import { Box, Heading } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useFilterStore } from "../stores/FilterStore";
import { capitalize } from "../utils";

export const NumberOfParksText: React.FC = () => {
  const { county: storeCounty } = useFilterStore(["county"]);
  const { county } = useParams();

  return (
    <Box bg="gray.50" borderBottomWidth={1} p={2}>
      <Heading as="h1" textAlign="center">
        Static Caravans for Sale in {capitalize(county || storeCounty)}
      </Heading>
    </Box>
  );
};
